import 'normalize.css';
import './index.css';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { App } from '~/App';
var root = createRoot(document.getElementById('app'));
root.render(React.createElement(StrictMode, null,
    React.createElement(RecoilRoot, null,
        React.createElement(App, null))));
